<template>
  <Modal :visible="visible"
         :close="false"
         :is-small="true"
         @hide="onCancel">
    <div class="wrapper">
      <div style="margin-bottom: 10px;">{{$t('community.report_title')}}</div>
      <div>{{$t('community.reason')}}</div>
      <input type="text" :placeholder="$t('community.reason_placeholder')" v-model="reason" style="margin:.5em 0 1em 0;">
      <div class="display-flex justify-end" style="width: 100%">
        <ion-button fill="clear" @click="onCancel">{{$t('common.cancel')}}</ion-button>
        <ion-button fill="clear" @click="onReport">{{$t('common.confirm')}}</ion-button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Modal";
import * as ajax from "../../utils/ajax";
import * as alert from "../../utils/alert";
import * as utils from "../../utils/utils";
export default {
  name: "ReportPopup",
  components:{Modal},
  props:{
    visible:{
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
      reason:""
    }
  },
  mounted() {

  },
  methods: {

    galleryInfo(url) {

      const splitUrl = url.split("/");
      const imageFileName = splitUrl[splitUrl.length-1];

      this.image = url;
    },
    onCancel(){
      this.reason = '';
      this.$emit('update:visible', false);
    },

    onReport(){
        const params = {
          board_no: this.$store.state.modal.data,
          report_type: 20,
          etc_reason: this.reason
        };
        ajax.Post(this, "/api/board/comment/report/", params, function(ref, data) {
          alert.alert("신고되었습니다.", "확인");
          ref.onCancel();
        });
    }
  }
}
</script>

<style scoped lang="scss">
.file_select {
  width: 120px;
  height: 30px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 15px;

  img {
    width: 15px;
    height: 15px;
    margin-right: 10px;
  }
}
.wrapper{
  padding: 2.5em .5em .5em 1.5em;
  width: 280px;
  background: white;
  font-weight: 200;
  border-radius: 5px;
  color: rgb(128, 128, 128);
}
input{
  width: 100%;
  border:none;
  outline: none;
  border-bottom: solid 2px transparent;
}

input:focus{
  border-bottom: solid 2px $primary-color;
  outline: none;
}
div.item-group {
  font-size: 14px;
  span.input-title {
    font-size: 14px;
  }
  div.input-group {
    margin-top: 6px;
    padding-bottom: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    input.no-outline {
      width: 100%;
    }
    ion-button {
      width: 65px;
      height: 23px;
    }

    // radio button
    div.radio-group {
      display: flex;
    }
  }
}

</style>